import vPanel from './Panel.vue';

export { vPanel };



// WEBPACK FOOTER //
// ./src/baseComponents/components/Panel/index.js